import 'components/partials/alerts/components/top-bar-alert/TopBarAlert.scss';

import './ScholarshipAlert.scss';

import classnames from 'classnames';
import LinkNav from 'components/partials/links/components/link-nav/LinkNav';
import { getPageLink } from 'helpers/resources';
import { isScholarshipPeriod } from 'helpers/user';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { hideScholarshipAlert } from 'store/parts/main/actions';

const propTypes = {
  className: PropTypes.string,
  // store
  isMobile: PropTypes.bool,
  topAlertVisible: PropTypes.bool,
  topAlertData: PropTypes.object,
  scholarshipAlertVisible: PropTypes.bool,
  hideScholarshipAlert: PropTypes.func
};

const ScholarshipAlert = ({
  className,
  isMobile,
  topAlertVisible,
  topAlertData = {},
  scholarshipAlertVisible,
  hideScholarshipAlert
}) => {
  const isPeriod = useMemo(() => {
    return isScholarshipPeriod();
  }, []);

  const shouldBeVisible =
    isPeriod &&
    scholarshipAlertVisible &&
    (!topAlertData?.title || !topAlertVisible);

  return !shouldBeVisible ? null : (
    <div
      className={classnames('top-bar-alert', 'scholarship-alert', className)}
    >
      <button
        onClick={() => hideScholarshipAlert()}
        type="button"
        className="close"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
      <span className="text container">
        <LinkNav to={getPageLink('page-scholarship-program')}>
          {isMobile
            ? 'MBA Scholarship Application Deadline is February 27, 2025.'
            : 'MBA Members & Dependents: the MBA Scholarship Application Deadline is February 27th, 2025.'}
        </LinkNav>
      </span>
    </div>
  );
};

ScholarshipAlert.propTypes = propTypes;

const mapStateToProps = state => ({
  isMobile: _get(state, 'main.isMobile'),
  topAlertVisible: _get(state, 'alert.visible'),
  topAlertData: _get(state, 'alert.data'),
  scholarshipAlertVisible: _get(state, 'main.scholarshipAlertVisible')
});

export default connect(mapStateToProps, { hideScholarshipAlert })(
  ScholarshipAlert
);
